// Third party
import * as React from 'react';

// Utils
import { categorizeLinks } from './categorize-links';

// UI
import { Typography } from '@components/typography';

/** The search page link type enum */
export enum SearchPageLinkType {
  /** Link to a nearby attraction */
  Attraction = 'ATTRACTION',
  /** Link to a blog */
  Blog = 'BLOG',
  /** Link to a city search URL */
  City = 'CITY',
  /** Link to a similar area */
  SimilarArea = 'SIMILAR_AREA',
}

export type SearchPageLinkPartial = {
  /** The href for the link */
  href: string;
  /** The title for the link */
  title: string;
  /** The type of link */
  type: SearchPageLinkType;
};

type Props = {
  searchPageLinks: SearchPageLinkPartial[];
};

export const SearchLinks: React.FC<Props> = ({ searchPageLinks }) => {
  return (
    <div className="relative block w-full py-8 space-y-4">
      {categorizeLinks(searchPageLinks).map((category, index) => {
        return (
          <div key={index}>
            <div className="w-full justify-between mx-auto text-white font-semibold shadow-t-lg">
              <Typography
                component="p"
                variant="title3"
                variantM="title2"
                className="text-black text-left"
              >
                {category.label}
              </Typography>
            </div>
            <div className="py-4 -mx-3">
              {category.links.map((link, index) => {
                return (
                  <a
                    key={index}
                    href={link.href}
                    target="_blank"
                    rel="noreferrer"
                    className="inline-flex mx-2 my-1 px-4 py-2 hover:text-primary-dark text-primary-main text-sm font-bold border-2 hover:border-primary-dark border-gray-light rounded-lg"
                  >
                    {link.title}
                  </a>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
